export enum CampaignsActions {
  run = 'run',
  edit = 'edit',
  duplicate = 'duplicate',
  pause = 'pause',
  delete = 'delete',
}
